import { render, staticRenderFns } from "./PlayAudioComponent.vue?vue&type=template&id=5ebad3dc&scoped=true&"
import script from "./PlayAudioComponent.vue?vue&type=script&lang=js&"
export * from "./PlayAudioComponent.vue?vue&type=script&lang=js&"
import style0 from "./PlayAudioComponent.vue?vue&type=style&index=0&id=5ebad3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebad3dc",
  null
  
)

export default component.exports